import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_ShiftY } from "./SVG_ShiftY";
import { QEncode } from "./QEncode";
import { SVG_CreateClipRect } from "./SVG_CreateClipRect";
import { BuildFontString } from "./BuildFontString";
import { MeasureTextHeightAdv } from "./MeasureTextHeightAdv";
import { Div2Floor } from "./Div2Floor";
import { NS_SVG } from "../constants";

export function SVG_DrawText(
  theMessage,
  x,
  y,
  textColor,
  fontFamily,
  fontSize,
  bold,
  italic,
  underline,
  alignment,
  vAlignment,
  clipRect,
  svgElement
) {
  x = SVG_ShiftX(x, svgElement);
  y = SVG_ShiftY(y, svgElement);

  var textObj = document.createElementNS(NS_SVG, "text");

  var xmlstr = QEncode(theMessage);
  var data = document.createTextNode(xmlstr);

  textObj.setAttribute("font-family", fontFamily);
  textObj.setAttribute("font-size", fontSize);
  textObj.setAttribute("x", x);
  textObj.setAttribute("y", y);
  textObj.setAttribute("fill", textColor);

  if (bold) textObj.setAttribute("font-weight", "bold");

  if (italic) textObj.setAttribute("font-style", "italic");
  if (underline) textObj.setAttribute("text-decoration", "underline");
  var svgAlignment = "start";
  switch (alignment) {
    case "right":
      svgAlignment = "end";
      break;
    case "center":
      svgAlignment = "middle";
      break;
  }

  textObj.setAttribute("text-anchor", svgAlignment);
  textObj.appendChild(data);

  if (clipRect) SVG_CreateClipRect(clipRect, textObj, svgElement);

  svgElement.appendChild(textObj);

  var fs = BuildFontString(fontFamily, fontSize, bold, italic);
  //var th = MeasureTextHeight(fs, fontSize);
  var tInfo = MeasureTextHeightAdv(fs, fontSize);
  var th = tInfo.fTxtHeight;
  var ho = tInfo.fHangingOffset;

  var dy = 0;

  switch (vAlignment) {
    case "middle":
      dy = Div2Floor(th) - Div2Floor(ho);
      break;
    case "top":
      dy = th;
      break;
    case "bottom":
      dy = 0;
      break;
  }

  dy = Math.floor(dy * 0.75); // WHAT IS THIS???

  textObj.setAttribute("dy", dy);
}
